import * as queryString from 'query-string';

export const isRenderingHeadlessly = Boolean(
  typeof window !== 'undefined' &&
    window.location.search &&
    queryString.parse(window.location.search).headless
);
